import { render, staticRenderFns } from "./ChoiceBoxMessage.vue?vue&type=template&id=1a0a6be1&scoped=true"
import script from "./ChoiceBoxMessage.vue?vue&type=script&lang=js"
export * from "./ChoiceBoxMessage.vue?vue&type=script&lang=js"
import style0 from "./ChoiceBoxMessage.vue?vue&type=style&index=0&id=1a0a6be1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a6be1",
  null
  
)

export default component.exports